module.exports = "images/noResult.8190dab9.png";